export { loadAspect, loadManyAspects, getConfig } from './load-aspect';
